export default "__VITE_ASSET__3xMvF3pS__"